import { endpoints } from 'api/endpoints'
import { GetOneResponse } from 'interfaces/api.interfaces'
import {
  MlExportConfig,
  MlExportConfigUpdate,
  MlResultConfig,
  MlResultConfigUpdate,
  ProjectSources,
  SourceBindingResult,
  SourceTitlesUpdate,
} from 'interfaces/api/projectMl.interfaces'
import { axios } from 'modules/axios'

const getExportConfig = async (projectId: number): GetOneResponse<MlExportConfig> => {
  const { data: response } = await axios.request<MlExportConfig>({
    method: 'GET',
    url: endpoints.projectMl.exportConfig(projectId),
  })
  return response
}

const updateExportConfig = async (projectId: number, data: MlExportConfigUpdate): GetOneResponse<MlExportConfig> => {
  const { data: response } = await axios.request<MlExportConfig>({
    method: 'PUT',
    url: endpoints.projectMl.exportConfig(projectId),
    data,
  })
  return response
}

const resetExportConfig = async (projectId: number): GetOneResponse<MlExportConfig> => {
  const { data: response } = await axios.request<MlExportConfig>({
    method: 'DELETE',
    url: endpoints.projectMl.exportConfig(projectId),
  })
  return response
}

const getResultConfig = async (projectId: number): GetOneResponse<MlResultConfig> => {
  const { data: response } = await axios.request<MlResultConfig>({
    method: 'GET',
    url: endpoints.projectMl.resultConfig(projectId),
  })
  return response
}

const updateResultConfig = async (projectId: number, data: MlResultConfigUpdate): GetOneResponse<MlResultConfig> => {
  const { data: response } = await axios.request<MlResultConfig>({
    method: 'PUT',
    url: endpoints.projectMl.resultConfig(projectId),
    data,
  })
  return response
}

const resetResultConfig = async (projectId: number): GetOneResponse<MlResultConfig> => {
  const { data: response } = await axios.request<MlResultConfig>({
    method: 'DELETE',
    url: endpoints.projectMl.resultConfig(projectId),
  })
  return response
}

const getSources = async (projectId: number): GetOneResponse<ProjectSources> => {
  const { data: response } = await axios.request<ProjectSources>({
    method: 'GET',
    url: endpoints.projectMl.sources(projectId),
  })
  return response
}

const bindSource = async (projectId: number, typeSource: string): GetOneResponse<SourceBindingResult> => {
  const { data: response } = await axios.request<SourceBindingResult>({
    method: 'POST',
    url: endpoints.projectMl.bindSource(projectId, typeSource),
  })
  return response
}

const unbindSource = async (projectId: number, typeSource: string): GetOneResponse<SourceBindingResult> => {
  const { data: response } = await axios.request<SourceBindingResult>({
    method: 'POST',
    url: endpoints.projectMl.unbindSource(projectId, typeSource),
  })
  return response
}

const updateSourceTitles = async (projectId: number, data: SourceTitlesUpdate): GetOneResponse<ProjectSources> => {
  const { data: response } = await axios.request<ProjectSources>({
    method: 'PATCH',
    url: endpoints.projectMl.sourceTitles(projectId),
    data,
  })
  return response
}

export const projectMlApi = {
  getExportConfig,
  updateExportConfig,
  resetExportConfig,
  getResultConfig,
  updateResultConfig,
  resetResultConfig,
  getSources,
  bindSource,
  unbindSource,
  updateSourceTitles,
}
